export default "__VITE_ASSET__vtzm_uLN__"